import { useState } from "react";
import { Box, ButtonBase } from "@mui/material";

import type { S132CurrentStatus } from "@thalamos/aspire-common";

import { S132HistoryDialogContainer } from "./S132HistoryDialogContainer.js";
import {
  s132DutyProvision,
  s132DutyText,
  S132StatusPill,
  s132StatusText,
} from "./S132StatusPill.js";

const cellLabel = (status: S132CurrentStatus, showSection: boolean): string =>
  `${showSection ? `${status.section}: ` : ""}${status.duty === "s132A" ? `${s132DutyText(status.duty)} ` : ""}${s132StatusText(status)}`;

export function S132DashboardCell(props: {
  patientId: string;
  patientName: string;
  statuses: S132CurrentStatus[];
  onChanged: () => void;
}) {
  const [open, setOpen] = useState(false);

  if (props.statuses.length === 0) return <>-</>;

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {props.statuses.map((status) => (
          <ButtonBase
            key={status.section}
            aria-label={`Open ${s132DutyProvision(status.duty)} information for ${props.patientName}: ${status.section}: ${s132StatusText(status)}`}
            onClick={() => {
              setOpen(true);
            }}
            sx={{ borderRadius: "999px", alignSelf: "flex-start" }}
          >
            <S132StatusPill
              status={status.status}
              label={cellLabel(status, props.statuses.length > 1)}
            />
          </ButtonBase>
        ))}
      </Box>
      {open && (
        <S132HistoryDialogContainer
          patientId={props.patientId}
          patientName={props.patientName}
          onClose={() => {
            setOpen(false);
          }}
          onChanged={props.onChanged}
        />
      )}
    </>
  );
}
